import { render, staticRenderFns } from "./batchRestDateDetail.vue?vue&type=template&id=1626fec3&scoped=true"
import script from "./batchRestDateDetail.vue?vue&type=script&lang=ts"
export * from "./batchRestDateDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1626fec3",
  null
  
)

export default component.exports